module.exports = __webpack_public_path__ + "static/sky-c4c5f28bfbcc067f68ee902ed07f5bac.png";